import React from 'react';
export const useErrorChecker = ({ name, meta, open, setOpen }) => {
    React.useEffect(() => {
        if (meta.submitFailed &&
            document.querySelector(`[data-form-error-name*="${name}"]`) &&
            !open) {
            setOpen(true);
        }
    }, [meta.submitFailed]);
};
